'use strict';
import TriggerHelper from 'App/services/TriggerHelper';

angular.module('upHelpers').service('TriggerHelper', [() => TriggerHelper]);
